import c from "./_common.js";
import f from "../../_styles/common/light.js";
function l(o) {
  const {
    textColorDisabled: t,
    iconColor: e,
    textColor2: n,
    fontSizeTiny: i,
    fontSizeSmall: m,
    fontSizeMedium: r,
    fontSizeLarge: s,
    fontSizeHuge: a
  } = o;
  return Object.assign(Object.assign({}, c), {
    fontSizeTiny: i,
    fontSizeSmall: m,
    fontSizeMedium: r,
    fontSizeLarge: s,
    fontSizeHuge: a,
    textColor: t,
    iconColor: e,
    extraTextColor: n
  });
}
const g = {
  name: "Empty",
  common: f,
  self: l
}, S = g;
export {
  S as default,
  l as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/empty/styles/light.js
// module id = 319
// module chunks = 41